<div class="row" style="margin-top: 10px;">
  <div class="col-lg-4">
    <div class="form-group has-float-label">
      <select class="form-control" [(ngModel)]="resource.RESOURCE_ID" (ngModelChange)="selectItem($event)">
        <option>SELECT</option>
        @for (item of listResourceSow; track item) {
          <option value="{{item.RESOURCE_ID}}">{{item.USERNAME}}</option>
        }
      </select>
      <label for="">Resource name *</label>
    </div>
  </div>
  <div class="col-lg-4">
    <div class="form-group has-float-label">
      <label class="form-control-plaintext" style="padding-top: 1.25rem; color: #000000;">
        {{ resource.RESOURCE_ID }}
      </label>
      <label for="">Resource ID</label>
    </div>
  </div>
  <div class="col-lg-4">
    <div class="form-group has-float-label">
      <label class="form-control-plaintext" style="padding-top: 1.25rem; color: #000000;">
        {{ resource.CONTRACTOR_ID }}
      </label>
      <label for="">ADP ID</label>
    </div>
  </div>
  <div class="col-lg-4">
    <div class="form-group has-float-label">
      <select class="form-control" [(ngModel)]="resource.PONUMBER" (ngModelChange)="getListPoNumberField()">
        <option>SELECT</option>
        @for (item of listPoNumber; track item) {
          <option value="{{item.PONUMBER}}">{{item.PONUMBER}}</option>
        }
      </select>
      <label for="">PO Number *</label>
    </div>
  </div>
  <div class="col-lg-8">
    <div class="form-group has-float-label">
      <select class="form-control" [(ngModel)]="resource.PO_LINE_ID" (ngModelChange)="selectItemPO($event)">
        <option>SELECT</option>
        @for (item of listPoNumberField; track item) {
          <option value="{{item.PO_LINE_ID}}">{{item.DESCRIPTION}}</option>
        }
      </select>
      <label for="">PO Line Description *</label>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group has-float-label">
      <select class="form-control" [(ngModel)]="resource.YEAR" >
        <option>SELECT</option>
        @for (item of listYear; track item) {
          <option value="{{item.YEAR}}">{{item.YEAR}}</option>
        }
      </select>
      <label for="">Year *</label>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group has-float-label">
      <select class="form-control" [(ngModel)]="resource.MONTH" >
        <option>SELECT</option>
        @for (item of listMonth; track item) {
          <option value="{{item.MONTH_NUMBER}}">{{item.MONTH_NUMBER}}</option>
        }
      </select>
      <label for="">Month *</label>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="form-group has-float-label">
      <input [(ngModel)]="resource.QUANTITY" class="form-control" id="" type="text"
        placeholder="Quantity" (input)="onQuantityInput($event)"/>
        <label for="">Quantity *</label>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="form-group has-float-label">
        <input [(ngModel)]="resource.RECEIPT_NUMBER" class="form-control" id="" type="text"
          placeholder="Receipt"/>
          <label for="">Receipt *</label>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="form-group has-float-label">
          <label class="form-control-plaintext" style="padding-top: 1.25rem; color: #000000;">
            {{ resource.RATE }}
          </label>
          <label for="">Rate</label>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="form-group has-float-label">
          <label class="form-control-plaintext" style="padding-top: 1.25rem; color: #000000;">
            {{ resource.AMOUNT_RECEIVED }}
          </label>
          <label for="">Amount</label>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="form-group has-float-label">
          <input [(ngModel)]="resource.INVOICE" class="form-control" id="" type="text"
            placeholder="Invoice"/>
            <label for="">Invoice</label>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="col-lg-4" style="float: right;">
            <button type="submit" class="btn btn-sm btn-block btn-danger claroredbg" (click)="saveReceipts()"><i class="fa fa-save"></i> Save</button>
          </div>
        </div>
      </div>
